import "../../../../src/content/find-peace-with-god/find-peace-with-god.scss";
import * as React from 'react';
export default {
  React
};